module.exports = {
	"application": {
		"menu": {
			"home": "Inicial",
			"plans": "Planos",
			"clients": "Clientes",
			"taxes": "Impostos",
			"contracts": "Assinaturas",
			"wrong_thing": "Ops... Aconteceu algo errado.",
			"lose_connection": "Problemas com conexão, verifique sua rede",
			"setup": "Configurações",
			"users_access": "Usuários de acesso",
			"general_settings": "Configurações gerais",
			"payment_settings": "Configurações de pagamento",
			"payment_select": "Selecionar adquirente",
			"billing_settings": "Configurações de faturamento",
			"webhook_settings": "Configurações de Webhook",
			"nfe_settings": "Configurações de Nota Fiscal Eletrônica",
			"invoices": "Faturas",
			"help": "Dúvidas",
			"orders": "Transações"
		},
		"login": {
			"account_created_with_success": "Conta criada! Seja bem vindo",
			"welcome": "Seja bem vindo!"
		},
		"alert": {
			"warning": "Atenção!",
			"danger": "Atenção!",
			"success": "Sucesso!",
			"info": "Atenção!",
			"inactive_plan": "Plano %{name} inativado!",
			"payment_failed": "Falha ao realizar pagamento.",
			"active_plan": "Plano %{name} ativado!",
			"effect_the_login": "Por favor efetue o login",
			"try_again": "Falha na comunicação, tente novamente!",
			"changed_plan_with_success": "Plano %{name} alterado!",
			"created_plan_with_success": "Plano criado!",
			"not_found": "Nenhum item encontrado!",
			"changes_have_been_saved": "As alterações foram salvas."
		},
		"pagination": {
			"found_items": {
				"singular": "%{count} item encontrado",
				"plural": "%{count} itens encontrados"
			},
			"display": "Exibir",
			"item": "item",
			"found": "encontrado",
			"items_per_page": "itens por página",
			"not_found_items": "nenhum item encontrado",
			"previous_page": "Página anterior",
			"next_page": "Próxima página",
			"current_page": "Página atual",
			"previous": "Anterior",
			"current": "Atual",
			"next": "Próxima"
		},
		"charcounter": {
			"remaining": {
				"singular": "caracter restante",
				"plural": "caracteres restantes"
			}
		},
		"select": {
			"results_not_found": "nenhum resultado encontrado",
			"results_could_not_loadeds": "Os resultados não puderam ser carregados",
			"searching": "Buscando...",
			"delete_the_char": "apague %{char} caracter",
			"enter_more_chars": "Digite %{char} ou mais caracteres",
			"load_more_results": "carregando mais resultados...",
			"select_itens": "você só pode selecionar %{itens} ite"
		},
		"button": {
			"contract": "Contratar um serviço",
			"launch": "Lançar Fatura",
			"close": "Fechar",
			"add_plan": "Adicionar plano",
			"remove_plan": "Remover plano",
			"confirm": "Confirmar",
			"inactive": "Inativar",
			"destroy": "Excluir",
			"active": "Ativar",
			"save": "Salvar",
			"cancel": "Cancelar",
			"include_plan": "Incluir Plano",
			"include_tax": "Incluir Imposto",
			"include_customer": "Incluir cliente",
			"new_contract": "Nova assinatura",
			"change": "Alterar",
			"edit": "Editar",
			"detail": "Detalhes",
			"include": "Incluir",
			"back": "Voltar",
			"continue": "Continuar",
			"login": "Entrar",
			"go_to_address": "Ir para endereço",
			"go_to_payment": "Ir para pagamento",
			"enter": "Entrar"
		},
		"header": {
			"recurrence": "Recorrência",
			"subscriptions_traycheckout": "Yapay Assinaturas",
			"administrator": "Administrador"
		},
		"menu_user": {
			"my_data": "Meus Dados",
			"plans": "Planos",
			"logout": "Sair"
		},
		"filter": {
			"all": "Todos",
			"active": "Ativo",
			"code": "Código",
			"day_expiration": "Dia de vencimento",
			"inactive": "Inativo",
			"filter": "Filtrar",
			"charge_type": "Tipo de cobrança",
			"contract_init_date": "Data inicial",
			"contract_end_date": "Data final",
			"init_value": "Valor inicial",
			"end_value": "Valor final",
			"clear_filters": "Limpar filtro"
		},
		"messages": {
			"not_found": "Nenhum item encontrado",
			"loading": "Carregando"
		},
		"validators": {
			"positive": "O valor deve ser positivo",
			"phone": "Telefone inválido",
			"percentage": "O valor deve estar entre 0,1 e 100",
			"day_expiration": "O dia do vencimento deve estar entre 1 e 31",
			"quantity_greater_than_allowed": "A quantidade deve ser menor que 1000.",
			"invalid_quantity": "A quantidade deve ser maior que %{quantity} (quantidade de vezes que o item já foi lançado nas faturas)",
			"uniqUsername": {
				"seller": {
					"username": "Endereço não pode ser utilizado."
				}
			},
			"usernameFormat": {
				"seller": {
					"username": "Endereço pode conter apenas letras (a-z), números (0-9) e traços (-)"
				}
			},
			"uniqEmail": {
				"seller": {
					"email": "E-mail já está sendo utilizado por outro usuário."
				}
			},
			"validCpf": {
				"cpf": "CPF inválido."
			},
			"validCnpj": {
				"cnpj": "CNPJ inválido."
			},
			"cep": {
				"invalid": "CEP inválido."
			},
			"date": {
				"past": "Data não pode ser no passado"
			},
			"validEmail": {
				"email": "Email já está em uso"
			}
		},
		"reset_password": {
			"email_not_found": "E-mail não encontrado",
			"email_sent": "Em instantes você receberá um e-mail com as instruções para alterar sua senha",
			"token_not_found": "Token expirado ou inválido",
			"first_access": "Primeira senha cadastrada com sucesso! Você será redirecionado para tela de contratação.",
			"already_registered": "Você já realizou o cadastro da sua primeira senha",
			"fail": "Falha ao cadastrar a senha",
			"new_password": "Cadastrar nova senha",
			"different_password": "Senhas não coincidem"
		},
		"error": {
			"required_field": "Campo obrigatório"
		},
		"attributes": {
			"customer": "O cliente",
			"name": "Nome",
			"password": "Senha",
			"invalid_method": "Método de pagamento inválido!",
			"email": "E-mail",
			"price": "Preço",
			"code": "Código",
			"value": "O valor",
			"periodicity": "Periodicidade",
			"quantity": "Quantidade",
			"contact": {
				"area_code": "DDD",
				"number": "Número"
			},
			"address": {
				"street": "Rua",
				"number": "Número"
			}
		}
	}
};


//////////////////
// WEBPACK FOOTER
// ./~/json-loader!./~/yaml-loader!./src/lang/pt-BR.yml
// module id = 589
// module chunks = 1